<template>
<v-row align="center">
  <br>
  <div class="icon">
    <a :href='url1' @click='clickData1' target=”_blank”>
      <img class="img" src="../assets/appStore.png" v-bind:style="height" >
    </a>
  </div>
  <div class="icon">
    <a :href='url2' @click='clickData2' target=”_blank”>
      <img class="img" src='../assets/googlePlayStore.png' v-bind:style="height2" >
    </a>
  </div>
</v-row>
</template>

<script>
import firebase from "firebase";
export default {
  name: 'icoon',
  props: ["name1","name2","imgSrc", 'height','height2', 'url1','url2'],
  methods:{
    clickData1:function(){
      firebase.analytics().logEvent(this.name1);
    },
    clickData2:function(){
      firebase.analytics().logEvent(this.name2);
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .icon{
    margin-top: 5%;

    /* text-align: center; */
  }
  #title{
    font-size: 16px;
    text-align: center;
  }
  .img{
    height: 50px;
    margin-top: 20px;
  }
  

</style>
